import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { OrderingService } from '../../services/ordering/ordering.service';

@Component({
    selector: 'isophi-app-sortable',
    templateUrl: './sortable.component.html',
    styleUrls: ['./sortable.component.scss'],
    standalone: false
})
export class SortableComponent {
  @Input() fieldName!: string;
  @Input() title!: string;

  @Input() ordering!: string[];
  @Output() orderingChange = new EventEmitter<string[]>();

  orderingService = inject(OrderingService);

  handleOrderingChange() {
    this.orderingService.handleOrderingChange(this.ordering, this.fieldName);
    this.orderingChange.emit(this.ordering);
  }

  isInOrdering(field: string) {
    return (
      this.orderingService.isFieldInOrdering(this.ordering, field) && this.orderingService.getFieldOrderingIndex(this.ordering, field) === 0
    );
  }
}
